import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'

export const useStyles = makeStyles((theme: Theme) => ({
  partnerSection: {
    margin: '50px auto',
    maxWidth: '890px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.87)',
    '& .MuiTypography-body1': {
      textAlign: 'center'
    },

    '& .MuiTypography-h2': {
      textAlign: 'center',
      marginBottom: '20px'
    },
    [theme.breakpoints.between(0, 'tablet')]: {
      paddingLeft: '23.5px',
      paddingRight: '23.5px'
    },
    [theme.breakpoints.between('tablet', 'desktop')]: {
      paddingRight: '90px',
      paddingLeft: '90px'
    }
  },
  pogImg: {
    margin: '20px'
  },
  mobileGridWrapper: {
    marginBottom: '70px'
  },
  mobileGrid: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '164px',
    minHeight: '86px',
    justifyContent: 'center'
  },
  imagesContainer: {
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '15px 0',
    [theme.breakpoints.between(0, 'tablet')]: {
      paddingRight: '6%',
      paddingLeft: '6%'
    },
    [theme.breakpoints.between('tablet', 'desktop')]: {
      // margin: '15px 0'
    },
    [theme.breakpoints.up('desktop')]: {
      margin: '15px 6%'
    }
  },
  imagesContainerSpacing: {
    '& > div': {
      display: 'flex',
      margin: '0px 10px'
    }
  },
  imagesWrapper: {
    [theme.breakpoints.between(0, 'tablet')]: {
      display: 'flex',
      alignItems: 'center',
      minWidth: '164px',
      minHeight: '86px',
      justifyContent: 'center'
    },
    [theme.breakpoints.between('tablet', 'desktop')]: {
      marginBottom: '15px',
      marginRight: '20px',
      marginLeft: '20px'
    }
  }
}))
